import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '../../components/page';

import Link from '@src/components/link';
import cx from 'classnames';
import { Checkbox, Input, Pagination } from 'antd';
const styles = require('./index.less');

const Main = () => {
  const store = useStore(() => new MainStore());
  // style={{ height: ` ${0.27083 * store.commitment.length}rem` }}

  const getLocationLabel = item => {
    // 检查 item.locations 是否存在
    if (!item || !item.locations) return null;

    const locationLabels = item.locations
      .map(location => {
        const { city, province } = location;
        const hasCity = Boolean(city);
        const hasProvince = Boolean(province);

        if (!hasCity && !hasProvince) return null;

        return (
          <div className={styles.itemLocation}>
            {hasCity && city}
            {hasCity && hasProvince && ', '}
            {hasProvince && province}
          </div>
        );
      })
      .filter(label => label !== null);

    if (locationLabels.length === 0) return null;

    return locationLabels;
  };
  const renderfilterContent = () => {
    if (store.mode === 'social') {
      return (
        <div className={styles.jobFilter}>
          <div className={styles.filterItem}>
            <div className={styles.titleBox}>
              <div className={styles.title}>{store.sections[1]?.list_title}</div>

              <Link className={cx(styles.iconArrow, store.locationFilterHide && styles.hide)} onClick={() => store.hideFilter('locationFilterHide')} />
            </div>

            <div className={cx(styles.filterBox, store.locationFilterHide && styles.hide)}>
              <Checkbox.Group options={store.jobLocationList} onChange={store.onLocationChange} />
            </div>
          </div>
          <div className={styles.filterItem}>
            <div className={styles.titleBox}>
              <div className={styles.title}>{store.sections[2]?.list_title}</div>
              <Link className={cx(styles.iconArrow, store.zhinengFilterHide && styles.hide)} onClick={() => store.hideFilter('zhinengFilterHide')} />
            </div>
            <div className={cx(styles.filterBox, store.zhinengFilterHide && styles.hide)}>
              <Checkbox.Group options={store.jobzhinengList} value={store.zhinengId} onChange={store.onzhinengChange} />
            </div>
          </div>
          <div className={styles.filterItem}>
            <div className={styles.titleBox}>
              <div className={styles.title}>{store.sections[3]?.list_title}</div>
              <Link className={cx(styles.iconArrow, store.departmentFilterHide && styles.hide)} onClick={() => store.hideFilter('departmentFilterHide')} />
            </div>

            <div className={cx(styles.filterBox, store.departmentFilterHide && styles.hide)}>
              <Checkbox.Group options={store.recruitmentType} value={store.recruitmentId} onChange={store.onRecruitmentChange} />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className={styles.jobFilter}>
          <div className={styles.filterItem}>
            <div className={styles.titleBox}>
              <div className={styles.title}>{store.sections[0]?.list_title}</div>
              <Link className={cx(styles.iconArrow, store.commitmenFilterHide && styles.hide)} onClick={() => store.hideFilter('commitmenFilterHide')} />
            </div>

            <div className={cx(styles.filterBox, store.commitmenFilterHide && styles.hide)}>
              <Checkbox.Group options={store.projectList} value={store.projectId} onChange={store.onProjectChange} />
            </div>
          </div>

          <div className={styles.filterItem}>
            <div className={styles.titleBox}>
              <div className={styles.title}>{store.sections[2]?.list_title}</div>
              <Link className={cx(styles.iconArrow, store.zhinengFilterHide && styles.hide)} onClick={() => store.hideFilter('zhinengFilterHide')} />
            </div>
            <div className={cx(styles.filterBox, store.zhinengFilterHide && styles.hide)}>
              <Checkbox.Group options={store.jobzhinengList} value={store.zhinengId} onChange={store.onzhinengChange} />
            </div>
          </div>
          <div className={styles.filterItem}>
            <div className={styles.titleBox}>
              <div className={styles.title}>{store.sections[1]?.list_title}</div>

              <Link className={cx(styles.iconArrow, store.locationFilterHide && styles.hide)} onClick={() => store.hideFilter('locationFilterHide')} />
            </div>

            <div className={cx(styles.filterBox, store.locationFilterHide && styles.hide)}>
              <Checkbox.Group options={store.jobLocationList} onChange={store.onLocationChange} />
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <Page className={styles.root}>
      {/* <div className={styles.test5} /> */}
      {/* <div className={styles.naviBarBox}>
        <NaviBar />
      </div> */}
      <div className={styles.kv} style={{ backgroundImage: `url("${store.pageConfig.kv_img}")` }}>
        <div className={styles.searchBox}>
          <div className={styles.searchInput}>
            <div className={styles.iconSearch} />
            <Input
              placeholder={store.pageConfig.search_placeholder}
              className={styles.codeInput}
              value={store.keyword}
              onChange={e => store.onChangeSearch(e.target.value)}
            />
          </div>
          <Link className={styles.btnSearch} onClick={() => store.clickSearch()}>
            {store.pageConfig.search_text}
          </Link>
        </div>
      </div>
      <div className={styles.contentBox}>
        <div className={styles.content}>
          {renderfilterContent()}
          <div className={styles.jobListContent}>
            <div className={styles.jobAllTitle}>
              {store.pageConfig.list_title} ({store.total})
            </div>

            {store.jobList.length > 0 ? (
              <React.Fragment>
                <div className={styles.jobList}>
                  {store.jobList.map((item, index) => {
                    return (
                      <Link
                        className={styles.jobItem}
                        key={index}
                        // target="_blank"
                        // href={`jobArticle.html?jobId=${item.id}&prior=${item.prior}`}
                        // href={`/#/jobArticle?jobId=${item.id}&prior=${item.prior}`}
                        onClick={() => store.clickJob(item)}
                      >
                        <div className={cx(styles.jobTitle, item.prior === 1 && styles.hotspot)}>
                          {item.prior === 1 && <div className={styles.iconHotspot} style={{ backgroundImage: `url("${store.pageConfig.list_icon}")` }} />}
                          {item.title}
                        </div>
                        <div className={styles.jobInfo}>
                          {/* <div className={styles.itemLabel}>{item.department.name}</div> */}
                          <div className={styles.itemLabel}>{item.commitment}</div>
                          <div className={styles.itemLabel}>{item.zhineng.name}</div>
                          {getLocationLabel(item)}
                          {/* {(item.locations[0]?.city || item.locations[0]?.province || item.locations[0]?.country || item.locations[0]?.province) && (
                            <div className={styles.itemLabel}>
                              {item.locations[0]?.city}
                              {item.locations[0]?.city && item.locations[0]?.province && ','}
                              {item.locations[0]?.province}
                            </div>
                          )} */}
                        </div>
                      </Link>
                    );
                  })}
                </div>
                <div className={styles.paginationBox}>
                  <Pagination size="small" pageSize={store.pageSize} current={store.currentPage} total={store.total} onChange={store.onPageChange} />
                </div>
              </React.Fragment>
            ) : (
              <div className={styles.notStatus}>
                <div className={styles.icon} style={{ backgroundImage: `url("${store.pageConfig.not_data}")` }} />
                <div className={styles.text}>{store.pageConfig.not_data_text}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Page>
  );
};

export default observer(Main);
